import * as DisplayItems from './display-items';

const SettingDisplayItems = {
  groupList: {
    [DisplayItems.CATEGORY]: DisplayItems.DISPLAY_GROUP_AGGREGATION_AXIS,
    [DisplayItems.AD_GROUP1]: DisplayItems.DISPLAY_GROUP_AGGREGATION_AXIS,
    [DisplayItems.AD_GROUP2]: DisplayItems.DISPLAY_GROUP_AGGREGATION_AXIS,
    [DisplayItems.SYNC_CATEGORY]: DisplayItems.DISPLAY_GROUP_AGGREGATION_AXIS,
    [DisplayItems.MEDIA_SIDE_CAMPAIGN]:
      DisplayItems.DISPLAY_GROUP_AGGREGATION_AXIS,
    [DisplayItems.MEDIA_SIDE_GROUP]:
      DisplayItems.DISPLAY_GROUP_AGGREGATION_AXIS,
    [DisplayItems.MEDIA_SIDE_AD_NAME]:
      DisplayItems.DISPLAY_GROUP_AGGREGATION_AXIS,
  },
  // 媒体シンク軸優先時に非表示にする項目
  denyMediaSyncList: [
    DisplayItems.CATEGORY,
    DisplayItems.AD_GROUP1,
    DisplayItems.AD_GROUP2,
  ],
  // エビス軸優先時に非表示にする項目
  denyEbisList: [
    DisplayItems.SYNC_CATEGORY,
    DisplayItems.MEDIA_SIDE_CAMPAIGN,
    DisplayItems.MEDIA_SIDE_GROUP,
  ],
  displayFreezeList: [
    DisplayItems.CATEGORY,
    DisplayItems.AD_GROUP1,
    DisplayItems.AD_GROUP2,
    DisplayItems.SYNC_CATEGORY,
    DisplayItems.MEDIA_SIDE_CAMPAIGN,
    DisplayItems.MEDIA_SIDE_GROUP,
    DisplayItems.MEDIA_SIDE_AD_NAME,
  ],
  orderList: {
    [DisplayItems.CATEGORY]: 2,
    [DisplayItems.AD_GROUP1]: 3,
    [DisplayItems.AD_GROUP2]: 4,
    [DisplayItems.SYNC_CATEGORY]: 5,
    [DisplayItems.MEDIA_SIDE_CAMPAIGN]: 6,
    [DisplayItems.MEDIA_SIDE_GROUP]: 7,
    [DisplayItems.IMPRESSION]: 9,
    [DisplayItems.CNT_ACCESS]: 10,
    [DisplayItems.CTR]: 11,
    [DisplayItems.CNT_SESSION]: 12,
    [DisplayItems.CNT_PV]: 13,
    [DisplayItems.PV_AVG]: 14,
    [DisplayItems.CNT_RETURN]: 15,
    [DisplayItems.PER_RETURN]: 16,
    [DisplayItems.TOTAL_STAY_TIME]: 17,
    [DisplayItems.TOTAL_STAY_TIME_AVG]: 18,
    [DisplayItems.TOTAL_LATENCY_TIME]: 19,
    [DisplayItems.LATENCY_TIME_AVG]: 20,
    [DisplayItems.CNT_CV_DETAIL]: 21,
    [DisplayItems.CNT_CV_TOTAL]: 22,
    [DisplayItems.CVR_DETAIL]: 23,
    [DisplayItems.CVR_TOTAL]: 24,
    [DisplayItems.CPA]: 25,
    [DisplayItems.CNT_INDIRECT2]: 26,
    [DisplayItems.CNT_INDIRECT3]: 27,
    [DisplayItems.CNT_INDIRECT4]: 28,
    [DisplayItems.CNT_INDIRECT5]: 29,
    [DisplayItems.CNT_INDIRECT_OTHER]: 30,
    [DisplayItems.INDIRECT_TOTAL]: 31,
    [DisplayItems.DIRECT_RATE]: 32,
    [DisplayItems.INDIRECT_RATE]: 33,
    [DisplayItems.CNT_FIRST]: 34,
    [DisplayItems.RCV]: 35,
    [DisplayItems.RCV_RATE]: 36,
    [DisplayItems.PRODUCTIVITY_RCV]: 37,
    [DisplayItems.RAMOUNT]: 38,
    [DisplayItems.RAMOUNT_RATE]: 39,
    [DisplayItems.PRODUCTIVITY_AMOUNT]: 40,
    [DisplayItems.COST]: 41,
    [DisplayItems.COST_RATE]: 42,
    [DisplayItems.CPC]: 43,
    [DisplayItems.TCPA]: 44,
    [DisplayItems.AMOUNT]: 45,
    [DisplayItems.ROAS]: 46,
    [DisplayItems.TROAS]: 47,
  },
  displayDefaultList: [
    DisplayItems.CATEGORY,
    DisplayItems.RCV,
    DisplayItems.PRODUCTIVITY_RCV,
    DisplayItems.RAMOUNT,
    DisplayItems.PRODUCTIVITY_AMOUNT,
    DisplayItems.COST,
  ],
  sortDefaultList: {
    [DisplayItems.PRODUCTIVITY_RCV]: DisplayItems.SORT_DIRECTION_DESC,
  },
};

const SettingAdDisplayItems = {
  ...SettingDisplayItems,
};

export const getAd = () => {
  const displayItemsBase = DisplayItems.getAd();
  return DisplayItems.getItems({
    ...SettingAdDisplayItems,
    displayItemsBase,
  });
};

export const getAdDefault = () => {
  const displayItemsBase = getAd();
  return DisplayItems.getDefault(displayItemsBase);
};
